import { config } from '../../config'
import * as Adapters from './Adapter'
import { AuthAdapter, User } from './auth.interface'

export function generateAdapter(): AuthAdapter<User | null> {
  return Adapters.adaptFirebaseAuth(config.firebase)
}
